import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Paper,
  InputAdornment,
  CircularProgress,
  Alert
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";

const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://swadvedamasalasbe.onrender.com/api";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { addToCart, fetchCart, setCart } = useCart();
  const [form, setForm] = useState({
    email: "",
    password: ""
  });
  const [pendingCartVal, setPendingCartVal] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // =========================
  // LOGIN HANDLER (FIXED)
  // =========================
const handleLogin = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
    // ✅ STEP 1: READ pendingCart BEFORE login
    const pendingCartRaw = localStorage.getItem("pendingCart");
    const pendingCart = pendingCartRaw ? JSON.parse(pendingCartRaw) : null;


    // 🔐 LOGIN API
    const res = await axios.post(`${API_URL}/auth/login`, form);
    const token = res.data.token;

    localStorage.setItem("token", token);

    // ✅ STEP 2: AUTH CONTEXT
    await login(token);

    // =========================
    // ✅ STEP 3: PUT YOUR CODE HERE 👇
    // =========================
    if (pendingCart && pendingCart.productId) {

      await axios.post(
        `${API_URL}/cart`,
        {
          productId: pendingCart.productId,
          quantity: pendingCart.quantity,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
await fetchCart();
      localStorage.removeItem("pendingCart");

      navigate("/cart");   // ✅ redirect to cart
    } else {
      navigate("/");       // ✅ normal login
    }

  } catch (err) {
    console.error(err);
    setError(err.response?.data?.message || "Login failed");
  } finally {
    setLoading(false);
  }
};

  return (
    <Grid container sx={{ minHeight: "100vh" }}>
      
      {/* LEFT SIDE */}
    <Grid
  item
  xs={12}
  md={6}
  sx={{
    position: "relative",
    backgroundImage: `url('/images/auth-spices.png')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff"
  }}
>
  {/* 🔥 DARK OVERLAY */}
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      background:
        "linear-gradient(135deg, rgba(139,0,0,0.8), rgba(0,0,0,0.7))"
    }}
  />

  {/* 🔥 TEXT CONTENT */}
  <Box
    sx={{
      position: "relative",
      zIndex: 1,
      textAlign: "center",
      px: 4
    }}
  >
    <Typography variant="h3" fontWeight="bold">
      Swadveda
    </Typography>

    <Typography sx={{ mt: 2, fontStyle: "italic" }}>
      जहाँ मसालों में बसता है विश्वास
    </Typography>

    <Typography sx={{ mt: 2, opacity: 0.9 }}>
      Discover the richness of authentic Indian spices crafted with purity,
      tradition, and unmatched flavor
    </Typography>
  </Box>
</Grid>

      {/* RIGHT SIDE */}
      <Grid
        item
        xs={12}
        md={6}
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ background: "#f9f5f2" }}
      >
        <Paper
          elevation={6}
          sx={{
            p: 4,
            width: "100%",
            maxWidth: 400,
            borderRadius: 3
          }}
        >
          <Typography variant="h5" fontWeight="bold" mb={1}>
            Welcome back to Swadveda
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            Pure spices. Authentic taste.
          </Typography>

          {error && <Alert severity="error">{error}</Alert>}

          <form onSubmit={handleLogin}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={form.email}
              onChange={handleChange}
              margin="normal"
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon />
                  </InputAdornment>
                )
              }}
            />

            <TextField
              fullWidth
              label="Password"
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              margin="normal"
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                )
              }}
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                mt: 3,
                py: 1.5,
                background: "linear-gradient(135deg, #C41E3A, #FF6B35)",
                fontWeight: "bold"
              }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Login"}
            </Button>
          </form>
          <Button
  fullWidth
  variant="text"
  onClick={() => navigate("/signup")}
  sx={{ mt: 1, color: "#C41E3A", fontWeight: "bold" }}
>
  Create an account
</Button>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Login;